const optionTypes = {
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
  SURFACE: 'surface',
  SLIDER: 'slider',
  ONLINE_STORE_CATEGORY: 'online-store-category',
  ONLINE_STORE_CLEAN_URL_SELECTOR: 'online-store-clean-url-selector',
  BREAKPOINTS_SLIDER: 'breakpoints-slider',
  DROPDOWN: 'dropdown',
  TOGGLE: 'toggle',
  CONTAINER_WIDTH: 'container_width',
};

export default optionTypes;
